import { TOGGLE_RELEASE_NOTES_MODALS  } from '../../../../helpers/releaseNotesConstants';

export const toggleReleaseNotesModals = (modals: any) => {
    return {
        type: TOGGLE_RELEASE_NOTES_MODALS,
        data: modals
    }
}
